export default __webpack_public_path__ + "static/media/mobile_book_session.90b6d991.png";